import * as React from "react";
const SvgBack = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M2.34,11,9.16,4.68a1,1,0,1,1,1.41,1.53l-4.9,4.52H21a1,1,0,1,1,0,2.08H5.6l5,5a1,1,0,0,1-.73,1.77,1,1,0,0,1-.74-.3L2.31,12.47A1,1,0,0,1,2,11.71,1.05,1.05,0,0,1,2.34,11Z" }));
export default SvgBack;
